import * as React from "react"
import { Label as LabelPrimitive } from "radix-ui"

import { cn } from "@/lib/utils"

/* Rótulo — arquivo do shadcn, reestilizado para a Colmeia.
 *
 * 13px, peso 600, --tinta-2 (6,8:1). Estava em peso 500: num formulário de
 * sete telas o rótulo é o que a pessoa varre para achar o campo que veio
 * preencher, e varrer só funciona se ele pesar mais que o texto de apoio ao
 * redor. Não vai a --tinta porque o VALOR digitado é que tem de ser o mais
 * escuro da linha.
 *
 * É o MESMO desenho da classe `.rotulo` (globals.css), e tem de continuar
 * sendo: rótulo de campo e rótulo de bloco são o mesmo degrau da hierarquia.
 * Se um dos dois mudar, mude o outro junto. */
function Label({
  className,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        "flex items-center gap-1 text-apoio leading-none font-semibold text-tinta-2 select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
        className
      )}
      {...props}
    />
  )
}

export { Label }
